module.exports = __webpack_public_path__ + "money.png?c2ce78cfbfca03ec73d006440d1e4c89";